module.exports = __webpack_public_path__ + "static/tg-logo-9053411bc5db3be5443166d02400c506.png";